'use client';

import AppImage from '@/components/ui/AppImage';

const AboutContentFrench = () => {
  return (
    <div className="relative bg-white">
      {/* Elegant Hero Section with Professional Photo */}
      <section className="relative overflow-hidden">
        {/* White background to match sections below */}
        <div className="absolute inset-0 bg-white"></div>
        
        {/* Subtle overlay for sophistication */}
        <div className="absolute inset-0 bg-white/20"></div>
        
        {/* Sophisticated background pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, #A47C48 1px, transparent 0)`,
            backgroundSize: '48px 48px'
          }}></div>
        </div>
        
        {/* Decorative geometric elements */}
        <div className="absolute top-0 right-0 w-96 h-96 border border-[#A47C48]/20 rounded-full translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 border border-[#A47C48]/20 rounded-full -translate-x-1/2 translate-y-1/2"></div>

        <div className="relative max-w-[1600px] mx-auto px-8 lg:px-20 py-12 lg:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            
            {/* Left: Professional Photo with Premium Frame */}
            <div className="relative lg:pl-12">
              
              <div className="relative">
                <div className="relative aspect-[3/4] max-w-md mx-auto overflow-hidden shadow-2xl">
                  <AppImage
                    src="/assets/images/Screenshot_20251214_151745_Gallery-1768826710153.jpg"
                    alt="Portrait professionnel de Maître Nadia Dridi, Associée fondatrice chez ND Law"
                    className="w-full h-full object-cover" />


                  {/* Sophisticated overlay gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0E3B3C]/40 via-transparent to-transparent"></div>
                </div>
              </div>
            </div>

            {/* Right: Name & Title with Elegant Typography */}
            <div className="text-[#0E3B3C] lg:pr-12">
              <div className="space-y-6">
                <div>
                  <h1
                    className="text-5xl lg:text-6xl mb-4 tracking-tight leading-none text-[#0E3B3C] font-light"
                    style={{ fontFamily: '"Playfair Display", serif' }}>

                    Maître Nadia Dridi
                  </h1>
                  <p className="text-2xl lg:text-3xl text-[#A47C48] font-light tracking-wider mb-6">Associée fondatrice

                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Section Parcours Professionnel avec Typographie Améliorée */}
      <section className="relative bg-white py-24 lg:py-32">
        {/* Remove subtle background texture - use clean white background */}

        <div className="relative max-w-[1400px] mx-auto px-8 lg:px-20">
          {/* En-tête de section élégant */}
          <div className="flex items-center gap-6 mb-16">
            <div className="flex items-center gap-3">
              
              <div className="w-24 h-[1px] bg-[#0E3B3C]"></div>
            </div>
            <h2 className="text-sm uppercase tracking-[0.3em] text-[#0E3B3C]/60 font-semibold">
              Profil Professionnel
            </h2>
          </div>

          <div className="space-y-8 max-w-5xl">
            <p className="text-[#0E3B3C] text-xl leading-[1.9] text-justify font-light first-letter:text-6xl first-letter:font-bold first-letter:text-[#0E3B3C] first-letter:mr-3 first-letter:float-left first-letter:leading-[0.9]" style={{ fontFamily: '"Crimson Text", serif' }}>
              Maître Nadia Dridi est une avocate inscrite au Barreau de Paris, spécialisée en arbitrage commercial international et en arbitrage d'investissement, avec une expérience acquise au sein de cabinets d'avocats internationaux de premier plan à Paris et en Asie et marquée par une implication soutenue dans des différends complexes et à forts enjeux, au plus haut niveau de la pratique internationale.
            </p>
            
            <p className="text-[#0E3B3C] text-xl leading-[1.9] text-justify font-light" style={{ fontFamily: '"Crimson Text", serif' }}>
              Sa pratique comprend la représentation dans des procédures d'arbitrage commercial et d'investissement de premier plan, conduites selon les règles d'arbitrage d'institutions majeures, notamment la CCI, le CIRDI, la LCIA et le SIAC, ainsi que selon le Règlement d'arbitrage de la CNUDCI. Elle est également intervenue dans des arbitrages fondés sur l'accord d'investissement de l'Organisation de la coopération islamique (OCI).
            </p>
            
            <p className="text-[#0E3B3C] text-xl leading-[1.9] text-justify font-light" style={{ fontFamily: '"Crimson Text", serif' }}>
              Elle a conseillé et représenté des États, des entités étatiques, des multinationales et des acteurs privés en Europe, dans la région MENA, en Afrique et en Asie, dans des affaires nécessitant une analyse juridique étroitement liée à des considérations politiques, des contraintes institutionnelles et des enjeux stratégiques.
            </p>
            
            <p className="text-[#0E3B3C] text-xl leading-[1.9] text-justify font-light" style={{ fontFamily: '"Crimson Text", serif' }}>
              Sa pratique repose sur une maîtrise rigoureuse du droit international public et privé, combinée à une compréhension approfondie de la manière dont les différends se déroulent en pratique dans des contextes gouvernementaux, d'entreprise et transfrontaliers.
            </p>
            
            <p className="text-[#0E3B3C] text-xl leading-[1.9] text-justify font-light" style={{ fontFamily: '"Crimson Text", serif' }}>
              Elle possède une vaste expérience dans des secteurs qui génèrent régulièrement des différends internationaux complexes, notamment la construction et les projets d'infrastructure à grande échelle, les télécommunications et l'énergie, y compris le pétrole et le gaz.
            </p>
            
            <div className="pt-8 pl-8 border-l-2 border-[#A47C48]">
              <p className="text-[#0E3B3C] text-xl leading-[1.9] text-justify font-light italic" style={{ fontFamily: '"Crimson Text", serif' }}>
                Ce qui distingue son approche, c'est sa capacité à opérer à l'intersection du droit, de la stratégie et du contexte. Elle apporte à chaque affaire une capacité à traduire les réalités institutionnelles, commerciales et culturelles d'un client en un plaidoyer arbitral efficace, en veillant à ce que ces dimensions soient non seulement comprises, mais intégrées de manière significative dans la conduite du différend.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Capacités Linguistiques avec Cartes Premium */}
      <section className="relative bg-white py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-8 lg:px-20">
          {/* En-tête de section élégant */}
          <div className="flex items-center justify-between mb-16">
            <div>
              <div className="flex items-center gap-6 mb-4">
                <div className="flex items-center gap-3">
                  
                  <div className="w-24 h-[1px] bg-[#0E3B3C]"></div>
                </div>
                <h2 className="text-sm uppercase tracking-[0.3em] text-[#0E3B3C]/60 font-semibold">
                  Représentation Multilingue
                </h2>
              </div>
              <h3
                className="text-3xl lg:text-4xl font-bold text-[#0E3B3C] tracking-tight"
                style={{ fontFamily: '"Playfair Display", serif' }}>

                Capacités linguistiques
              </h3>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="group relative bg-gradient-to-br from-[#F4F1EA] to-white p-10 transition-all duration-500 hover:shadow-2xl border border-[#0E3B3C]/5">
              <div className="relative">
                <div className="mb-6">
                  <h3 className="text-2xl font-semibold text-[#0E3B3C] mb-2 tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                    Maîtrise professionnelle
                  </h3>
                </div>
                <p className="text-[#0E3B3C] text-lg leading-relaxed font-light">
                  Français · Anglais · Arabe
                </p>
              </div>
            </div>
            
            <div className="group relative bg-gradient-to-br from-[#F4F1EA] to-white p-10 transition-all duration-500 hover:shadow-2xl border border-[#0E3B3C]/5">
              <div className="relative">
                <div className="mb-6">
                  <h3 className="text-2xl font-semibold text-[#0E3B3C] mb-2 tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                    Compétence de travail
                  </h3>
                </div>
                <p className="text-[#0E3B3C] text-lg leading-relaxed font-light">
                  Espagnol
                </p>
              </div>
            </div>
            
            <div className="group relative bg-gradient-to-br from-[#F4F1EA] to-white p-10 transition-all duration-500 hover:shadow-2xl border border-[#0E3B3C]/5">
              <div className="relative">
                <div className="mb-6">
                  <h3 className="text-2xl font-semibold text-[#0E3B3C] mb-2 tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                    Compréhension
                  </h3>
                </div>
                <p className="text-[#0E3B3C] text-lg leading-relaxed font-light">
                  Khmer
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Expertise Sectorielle avec Design Sophistiqué */}
      <section className="relative bg-white py-24 lg:py-32 overflow-hidden">
        {/* Motif de fond élégant */}
        <div className="absolute inset-0 opacity-[0.02]">
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, #A47C48 1px, transparent 0)`,
            backgroundSize: '48px 48px'
          }}></div>
        </div>

        <div className="relative max-w-[1400px] mx-auto px-8 lg:px-20">
          {/* En-tête de section premium */}
          <div className="mb-16">
            <div className="flex items-center gap-6 mb-4">
              <div className="flex items-center gap-3">
                
                <div className="w-24 h-[1px] bg-[#0E3B3C]"></div>
              </div>
              <h2 className="text-sm uppercase tracking-[0.3em] text-[#0E3B3C]/60 font-semibold">
                Domaines de Pratique
              </h2>
            </div>
            <h3
              className="text-3xl lg:text-4xl font-bold text-[#0E3B3C] mb-6 tracking-tight"
              style={{ fontFamily: '"Playfair Display", serif' }}>

              Expertise sectorielle
            </h3>
            <p className="text-[#0E3B3C]/70 text-xl leading-relaxed font-light whitespace-nowrap">
              Expérience approfondie dans les secteurs générant régulièrement des différends internationaux complexes
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Construction & Infrastructures */}
            <div className="group relative bg-gradient-to-br from-[#F4F1EA] to-white p-6 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl border border-[#0E3B3C]/5">
              
              <div className="mb-4">
                
                <h3 className="text-3xl font-bold text-[#0E3B3C] mb-4 tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                  Construction &<br />Infrastructures
                </h3>
              </div>
              
              <p className="text-[#0E3B3C]/80 text-base leading-relaxed font-light text-justify">
                Projets d'infrastructure à grande échelle et litiges complexes en matière de construction
              </p>
            </div>

            {/* Technologie */}
            <div className="group relative bg-gradient-to-br from-[#F4F1EA] to-white p-6 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl border border-[#0E3B3C]/5">
              
              <div className="mb-4">
                
                <h3 className="text-3xl font-bold text-[#0E3B3C] mb-4 tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                  Technologie
                </h3>
              </div>
              
              <p className="text-[#0E3B3C]/80 text-base leading-relaxed font-light text-justify">
                Arbitrage dans les secteurs de la technologie et des télécommunications
              </p>
            </div>

            {/* Énergie et ressources naturelles */}
            <div className="group relative bg-gradient-to-br from-[#F4F1EA] to-white p-6 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl border border-[#0E3B3C]/5">
              
              <div className="mb-4">
                
                <h3 className="text-3xl font-bold text-[#0E3B3C] mb-4 tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                  Énergie et<br />ressources naturelles
                </h3>
              </div>
              
              <p className="text-[#0E3B3C]/80 text-base leading-relaxed font-light text-justify">
                Différends intervenant dans l'ensemble de la chaîne de valeur de l'énergie et des ressources naturelles, notamment dans les secteurs du pétrole et du gaz, des mines, des métaux, des énergies renouvelables et des infrastructures liées à l'énergie
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>);

};

export default AboutContentFrench;